export default "// src/index.js\n\nimport './src/sass/main.scss'\n// OR\nrequire('./src/sass/main.scss')\n";